import React from 'react'
import CloseLargeIcon from '@8x8/oxygen-icon/novo/CloseLargeIcon'
import styled from 'styled-components'

import { FlexCentered } from '~/components/common/containers'
import { Z_INDEX } from '~/core/constants'
import { translate } from '~/core/translate'

import { hideDialog } from '~/actions/ui'
import { useSelector } from 'react-redux'
import { getIsMobileSummaryPage } from '~/selectors/app'

import { IconButton } from '@8x8/oxygen-button'

const Container = styled(FlexCentered)`
  display: flex;
  gap: 12px;
  padding: 2px;
  border-radius: 6px;
  position: absolute;
  top: ${({ hasVerticalOffset }) => hasVerticalOffset ? '48px' : '24px'};
  z-index: ${Z_INDEX.MODALS};
  right: 16px;
  background-color: ${({ theme }) => theme._neo.ui06};

  svg {
    padding: 2px;
    border-radius: 6px;
    color: white;
    cursor: pointer;

    &:not(:first-child) {
      margin-left: 16px;
    }
  }
`

const StyledCloseLargeIcon = styled(CloseLargeIcon)`
  size: 24px;
  color: ${({ theme }) => theme._neo.icon01};
`

const SlideshowControls = ({ canClose, children }) => {
  const isMobileSummary = useSelector(getIsMobileSummaryPage)

  return (
    <Container hasVerticalOffset={isMobileSummary}>
      {children}
      {canClose && (
        <IconButton
          data-test-id='slide-close-button'
          onClick={hideDialog}
          aria-label={translate('aria_close_recording_modal')}
        >
          <StyledCloseLargeIcon />
        </IconButton>
      )}
    </Container>
  )
}

export default SlideshowControls
